import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_CLASSSECTION,
  GET_CLASSSECTIONS,
  GET_CLASSSECTIONS_BY_FILTER,
  GET_CLASSSECTIONS_BY_STUDENT_NOT_REGISTER,
  ADD_CLASSSECTION,
  UPDATE_CLASSSECTION,
  DELETE_CLASSSECTION
} from '../../../../../queries/modules/courses/class-section.js';

export async function getClassSections(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSSECTIONS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.classSection;
    } else {
      context.commit('setClassSections', data.getClassSections);
      context.commit('setSuccess', null);
      return data.getClassSections
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function getClassSectionsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSSECTIONS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setClassSections', data.getClassSectionsByFilter);
      context.commit('setSuccess', null);

      return data.getClassSectionsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getClassSectionsByStudentNotRegister(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSSECTIONS_BY_STUDENT_NOT_REGISTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setClassSections', data.getClassSectionsByStudentNotRegister);
      context.commit('setSuccess', null);

      return data.getClassSectionsByStudentNotRegister;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getClassSection(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSSECTION,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.classSection;
    } else {
      context.commit('setClassSection', data.getClassSection);
      context.commit('setSuccess', null);
      return data.getClassSection
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function getClassSectionForLearning(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSSECTION,
        variables: payload,
        context: { clientName: 'Prisma2' },
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.getClassSection
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

/**
 *  Action to Add Course Outline Registration
 *
 *   @param  {Object} context Vuex context object.
 *     @property {Vuex method (Function)} commit : "To commit a mutation"
 *
 *   @param  {Object} payload Contain requires inputs for adding data
 *     @property {ClassSectionInput (Array), required} classSectionInput : [{
          academicPeriodId: "", // {String} Get it from filter selection.
          periodCode: "",       // {String} Get it from filter selection.
          degreeId: "",         // {String} Get it from filter selection.
          subjectGroupId: "",   // {String} Get it from filter selection.
          subjectId: "",        // {String} Get it from Course Outline Selection.
          subjectCode: "",      // {String} "----------------------------------"
          subjectName: "",      // {String} "----------------------------------"
          courseOutlineId: "",  // {String} "----------------------------------"
          teacherId: "",        // {String} "----------------------------------"
          teacherCode: "",      // {String} "----------------------------------"
        }]
 *   @param  {Boolean} useState boolean if true method will set state will return data, Default: true
 *
 */
export async function addClassSection(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_CLASSSECTION,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const classSections = [...context.state.classSections];
      classSections.push(data.addClassSection);
      context.commit('setClassSections', classSections);
      context.commit('setSuccess', newItemSuccess('Section ' + data.addClassSection.sectionNo));

      return data.addClassSection
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateClassSection(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_CLASSSECTION,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.classSections.findIndex(item => item.id === data.updateClassSection.id);
      const classSections = [
        ...context.state.classSections.slice(0, index),
        data.updateClassSection,
        ...context.state.classSections.slice(index + 1)
      ];
      context.commit('setClassSections', classSections);
      context.commit('setSuccess', updateItemSuccess('Section ' + data.updateClassSection.sectionNo));

      return data.updateClassSection
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

/**
 *  Action to Delete Course Outline Registration
 *
 *   @param  {Object} context Vuex context object.
 *     @property {Vuex method (Function)} commit : "To commit a mutation"
 *
 *   @param  {Object} payload Contain requires inputs for adding data
 *     @property {ID (String), required} id : "ID of a Course Outline Registration"
 *
 */
export async function deleteClassSection(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_CLASSSECTION,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.classSections.findIndex(item => item.id === data.deleteClassSection.id);
      const classSections = [
        ...context.state.classSections.slice(0, index),
        ...context.state.classSections.slice(index + 1)
      ];
      context.commit('setClassSections', classSections);
      context.commit('setSuccess', deleteItemSuccess('Section ' + data.deleteClassSection.sectionNo));

      return data.deleteClassSection
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

